"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instantiate = void 0;
const instantiate = (classes, name) => {
    const clazz = classes[name];
    try {
        return [clazz, new clazz({})];
    }
    catch {
        return [clazz, undefined];
    }
};
exports.instantiate = instantiate;
